module.exports = __webpack_public_path__ + "ae8d56a987cf2d957a1172f678a364cd.png";